import { HStack, Spacer, Tooltip, VStack } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

type TreeMapTooltipEntry = {
  label: string;
  value: string;
};

export type TreeMapTooltipProps = PropsWithChildren & {
  title?: string;
  entries?: TreeMapTooltipEntry[];
};

export const TreeMapTooltip = ({
  title,
  entries,
  children,
}: TreeMapTooltipProps) => {
  return (
    <Tooltip
      hasArrow
      padding="12px"
      placement="top"
      offset={[0, 2]}
      bg="var(--ui-text-normal, #2d426a)"
      borderRadius="4px"
      label={
        <VStack spacing={1} align="stretch" px="7px">
          {title && (
            <div style={{ color: '#fff', fontWeight: 600, fontSize: '12px' }}>
              {title}
            </div>
          )}
          {entries?.map((entry, index) => {
            return (
              <HStack key={index} spacing={4} height="18px">
                <div style={{ color: '#fff', fontSize: '11px' }}>
                  {entry.label}
                </div>
                <Spacer />
                <div style={{ color: '#fff', fontSize: '11px' }}>
                  {entry.value}
                </div>
              </HStack>
            );
          })}
        </VStack>
      }
    >
      {children}
    </Tooltip>
  );
};
